import { Col, Form, Row, Switch } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { InputPassword } from 'src/components/Formik'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}

export default function UserSetPassword({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <Row gutter={24}>
      {!!formikProps.values.user_id && (
        <Col span={3}>
          <Form.Item label={t('web.side.user.change-password.title')}>
            <Switch
              onChange={checked => {
                formikProps.setFieldValue('change_password', checked)

                formikProps.setFieldValue('password', '')

                if (!checked) {
                  formikProps.unregisterField('password')
                }
              }}
            />
          </Form.Item>
        </Col>
      )}
      {(!formikProps.values.user_id || formikProps.values.change_password) && (
        <>
          <Col span={formikProps.values.user_id ? 5 : 8}>
            <InputPassword
              formikProps={formikProps}
              label="web.user.common.password.title"
              name="password"
            />
          </Col>
          <Col span={formikProps.values.user_id ? 5 : 8}>
            <InputPassword
              formikProps={formikProps}
              label="web.user.common.confirm_password.title"
              name="confirm_password"
            />
          </Col>
        </>
      )}
    </Row>
  )
}
